import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import TextField from './TextField.js';
import useConfigWithExtraValidation from '../../utils/form/useExtraFieldValidation.js';

function getPhoneNumberError(value) {
  var trimmedValue = typeof value === 'string' && value.trim();
  if (trimmedValue) {
    if (/\D/.test(trimmedValue)) {
      // has non-numbers
      return 'Must be numeric';
    }
    if (value.length !== 10) {
      return 'Must be 10 digits';
    }

    // else its a valid phone number, no errors
    return null;
  }

  // else no phone number to validate, I don't enforce "required" in this rule. No errors.
  return null;
}
function PhoneField(textFieldProps) {
  return /*#__PURE__*/React.createElement(TextField, _extends({}, textFieldProps, {
    // Add phone number validation
    config: useConfigWithExtraValidation(textFieldProps.config, getPhoneNumberError)
    // Add phone number masking
    ,
    mask: {
      // Phone without extension
      mask: '(999) 999-9999',
      placeholder: '_',
      autoUnmask: true
    },
    autoComplete: "off",
    placeholder: "(___) ___-____"
  }));
}
PhoneField.propTypes = process.env.NODE_ENV !== "production" ? TextField.propTypes : {};
PhoneField.defaultProps = TextField.defaultProps;

export { PhoneField as default, getPhoneNumberError };
